import React, { useState } from "react";
import { TPlainUser } from "../../../../../domain/codecs/User";
import { CRMColors } from "../../../models/CRMColors";
import { CRMSpacing } from "../../../models/CRMSpacing";
import { FontQuicksand } from "../../BuildingBlocks/FontQuicksand";
import { Text } from "../../BuildingBlocks/Text";
import { SpacingColumn } from "../../BuildingBlocks/SpacingColumn";
import { getJobAssigneeDisplay } from "./jobAssigneeDisplay";

type TCRMJobAssignedCellProps = {
    assignedTo: string | null;
    assignableUsers: Array<TPlainUser>;
    // Who the chip can NAME is wider than who it can assign to: the picker is scoped to
    // front-line staff by a founder decision (bf35e9fd5), so an owner outside it — an
    // admin, or anyone whose role changed since — has to resolve from somewhere.
    knownUsers?: Array<TPlainUser>;
    onReassign: (assignedTo: string) => void;
};

export const CRMJobAssignedCell = (props: TCRMJobAssignedCellProps): JSX.Element => {
    const [isOpen, setIsOpen] = useState(false);

    const assignee = getJobAssigneeDisplay(
        props.assignedTo,
        [...props.assignableUsers, ...props.knownUsers ?? []],
    );

    const toggle = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setIsOpen(!isOpen);
    };

    const reassign = (e: React.MouseEvent, userId: string) => {
        e.preventDefault();
        e.stopPropagation();
        props.onReassign(userId);
        setIsOpen(false);
    };

    return (
        <div style={{ position: "relative" }}>
            <div
                onClick={toggle}
                title={assignee.title}
                style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "28px",
                    height: "28px",
                    borderRadius: "50%",
                    cursor: "pointer",
                    backgroundColor: assignee.isAssigned ? CRMColors.PRIMARY_10 : CRMColors.NEUTRAL_10,
                    border: `1px ${assignee.isAssigned ? "solid" : "dashed"} ${CRMColors.NEUTRAL_6}`,
                }}
            >
                <FontQuicksand>
                    <Text size={11} weight={700} color={CRMColors.NEUTRAL_INK}>
                        {assignee.initials}
                    </Text>
                </FontQuicksand>
            </div>

            {isOpen &&
                <div
                    style={{
                        position: "absolute",
                        zIndex: 10,
                        top: "32px",
                        right: "0px",
                        maxHeight: "220px",
                        overflowY: "auto",
                        minWidth: "180px",
                        backgroundColor: CRMColors.NEUTRAL_PAPER,
                        border: `1px solid ${CRMColors.NEUTRAL_8}`,
                        borderRadius: "5px",
                        boxShadow: `0px 4px 12px rgba(0,0,0,0.15)`,
                    }}
                >
                    <SpacingColumn>
                        {props.assignableUsers.map((user) => (
                            <div
                                key={user.id}
                                onClick={(e) => reassign(e, user.id)}
                                style={{
                                    padding: `${CRMSpacing.SMALL} ${CRMSpacing.MEDIUM}`,
                                    cursor: "pointer",
                                    backgroundColor: user.id === props.assignedTo ? CRMColors.NEUTRAL_12 : CRMColors.NEUTRAL_PAPER,
                                }}
                            >
                                <FontQuicksand>
                                    <Text size={13} weight={500} color={CRMColors.NEUTRAL_INK}>
                                        {user.first_name} {user.last_name}
                                    </Text>
                                </FontQuicksand>
                            </div>
                        ))}
                    </SpacingColumn>
                </div>
            }
        </div>
    );
};
